(() => {
  document.querySelectorAll('[data-about-trust-rail]').forEach((rail) => {
    const viewport = rail.querySelector('[data-trust-viewport]');
    const items = Array.from(rail.querySelectorAll('[data-trust-item]'));
    if (!viewport || !items.length) return;

    let frame = 0;
    let lastUpdate = 0;

    const updateCurrent = (time = 0) => {
      if (time - lastUpdate > 150) {
        const viewportRect = viewport.getBoundingClientRect();
        const center = viewportRect.left + viewport.clientWidth / 2;
        let nearest = items[0];
        let distance = Infinity;

        items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const itemDistance = Math.abs(rect.left + rect.width / 2 - center);
          const edgeDistance = Math.min(rect.right - viewportRect.left, viewportRect.right - rect.left);
          const edgeRatio = Math.max(0, Math.min(1, edgeDistance / Math.max(1, rect.width)));
          item.style.setProperty('--trust-opacity', String(.18 + edgeRatio * .54));
          if (itemDistance < distance) {
            distance = itemDistance;
            nearest = item;
          }
        });

        items.forEach((item) => item.classList.toggle('is-current', item === nearest));
        lastUpdate = time;
      }
      frame = window.requestAnimationFrame(updateCurrent);
    };

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.innerWidth > 640) {
      frame = window.requestAnimationFrame(updateCurrent);
    } else {
      items[0]?.classList.add('is-current');
    }

    window.addEventListener('pagehide', () => window.cancelAnimationFrame(frame), { once: true });
  });

  document.querySelectorAll('[data-about-process]').forEach((section) => {
    const targets = Array.from(section.querySelectorAll('[data-process-step], [data-process-reveal]'));
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = targets.indexOf(entry.target);
        entry.target.style.transitionDelay = `${Math.max(0, index) * 70}ms`;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .16 });

    targets.forEach((target) => observer.observe(target));
  });
})();
